<template>
	<v-form>

		<h3 class="mt-8 mb-4">Redes sociales y medios de contacto</h3>

    <v-text-field
      v-model="value.medios.whatsapp.valor"
      label="Número telefónico de Whatsapp con prefijo de país"
    ></v-text-field>

    <v-text-field
      v-model="value.medios.instagram.valor"
      label="Nombre de usuario o dirección URL de Instagram"
    ></v-text-field>

    <v-text-field
      v-model="value.medios.facebook.valor"
      label="Nombre de usuario o dirección URL de Facebook"
    ></v-text-field>

    <v-text-field
      v-model="value.medios.twitter.valor"
      label="Nombre de usuario o dirección URL de Twitter"
    ></v-text-field>

    <v-text-field
      v-model="value.medios.youtube.valor"
      label="Nombre de usuario o dirección URL de Youtube"
    ></v-text-field>

    <v-text-field
      v-model="value.medios.linkedin.valor"
      label="Nombre de usuario o dirección URL de Linkedin"
    ></v-text-field>

    <v-text-field
      v-model="value.medios.correoElectrónico.valor"
      label="Dirección de correo electrónico"
    ></v-text-field>

    <v-text-field
      v-model="value.medios.númeroTelefónico.valor"
      label="Número telefónico"
    ></v-text-field>

  </v-form>
</template>

<script>

export default {
	name: 'ConfiguracionRedesSociales',

	data: () => ({
		//
	}),

	props: {
		value: {
			type: Object,
			required: true
		},
	},

}
</script>
